import ExcelJS from "exceljs";

// export async function exportToExcel(filteredData, storess) {
//   const workbook = new ExcelJS.Workbook();
//   const sheet = workbook.addWorksheet("Sales");

//   const headerStyle = {
//     font: { bold: true, color: { argb: "FFFFFFFF" } },
//     fill: { type: "pattern", pattern: "solid", fgColor: { argb: "FF0070C0" } },
//   };

//   // --- Updated Header: Added Items after Status ---
//   const headerRow = sheet.addRow([
//     "Brand",
//     "Store",
//     "Date",
//     "Tran ID",
//     "Sales",
//     "Payment Type 1",
//     "Amount 1",
//     "Payment Type 2",
//     "Amount 2",
//     "Payment Type 3",
//     "Amount 3",
//     "Status",
//     "Items (Code - Description - Amount)", // new column
//   ]);
//   headerRow.eachCell((cell) => Object.assign(cell, headerStyle));

//   filteredData.forEach((data) => {
//     // Extract items -> only code, description, and AMOUNT
//     let itemsText = "";
//     if (Array.isArray(data.items)) {
//       itemsText = data.items
//         .map((item) => {
//           const code = item.code || "";
//           const desc = item.description || "";
//           const amountProp = item.customProperties?.find(
//             (p) => p.codeName === "AMOUNT"
//           );
//           const amount = amountProp?.value || "0.00";
//           return `${code} - ${desc} - ₱${amount}`;
//         })
//         .join("\n"); // put each item on a new line
//     }

//     sheet.addRow([
//       "Angels Pizza",
//       storess,
//       data.tran_date,
//       data.tran_id,
//       data.total,
//       data.paymenttype,
//       data.paymenttypetotal,
//       data.paymenttype2,
//       data.paymenttype2total,
//       data.paymenttype3,
//       data.paymenttype3total,
//       data.status,
//       itemsText, // new column
//     ]);
//   });

//   // (the rest of your summaries & report code stays unchanged)

//   // 2) Payment Type Summary (across all three slots)
//   sheet.addRow([]);
//   sheet.addRow(["\uD83D\uDCB3 PAYMENT TYPE SUMMARY"]);
//   const summaryHeader = sheet.addRow(["Payment Type", "Count", "Total Sales"]);
//   summaryHeader.eachCell((cell) => Object.assign(cell, headerStyle));

//   const paymentSummary = {};
//   filteredData
//     .filter((data) => data.status === "C")
//     .forEach((data) => {
//       ["", "2", "3"].forEach((suf) => {
//         const type = data[`paymenttype${suf}`]?.trim();
//         const amt = parseFloat(data[`paymenttype${suf}total`]) || 0;
//         if (type && type !== "-") {
//           if (!paymentSummary[type]) {
//             paymentSummary[type] = { count: 0, total: 0 };
//           }
//           paymentSummary[type].count++;
//           paymentSummary[type].total += amt;
//         }
//       });
//     });
//   Object.entries(paymentSummary).forEach(([type, { count, total }]) => {
//     sheet.addRow([type.toUpperCase(), count, total]);
//   });

//   // 3) Transaction Type Summary (unchanged)
//   sheet.addRow([]);
//   sheet.addRow(["\uD83D\uDDFE TRANSACTION TYPE SUMMARY"]);
//   const txnHeader = sheet.addRow(["Transaction Type", "Count", "Total Sales"]);
//   txnHeader.eachCell((cell) => Object.assign(cell, headerStyle));

//   const transactionTypes = {
//     D: "Dinein",
//     K: "Drive-Thru",
//     T: "Take-out",
//     G: "GrabFood",
//     P: "Pickup",
//     U: "Delivery",
//     B: "deltime",
//     F: "FoodPanda",
//     H: "Tablevibe",
//   };
//   const tranSummary = {};
//   filteredData
//     .filter((data) => data.status === "C")
//     .forEach(({ tran_type, total }) => {
//       const code = tran_type?.trim();
//       if (code && transactionTypes[code]) {
//         if (!tranSummary[code]) {
//           tranSummary[code] = { count: 0, total: 0 };
//         }
//         tranSummary[code].count++;
//         tranSummary[code].total += parseFloat(total || 0);
//       }
//     });
//   Object.entries(tranSummary).forEach(([code, { count, total }]) => {
//     sheet.addRow([transactionTypes[code], count, total]);
//   });

//   // --- NEW: Compute totals for Report Summary from filteredData ---
//   const totals = filteredData.reduce(
//     (acc, d) => {
//       const total = parseFloat(d.total) || 0;
//       const discount = parseFloat(d.discount_amount) || 0;
//       const pretax = parseFloat(d.total_pretax) || 0;
//       const tax = parseFloat(d.total_tax) || 0;
//       const taxfree = parseFloat(d.total_taxfree) || 0;
//       const status = d.status?.trim();

//       if (status === "C") {
//         acc.gross += total; // Gross Sales
//         acc.net += total - tax; // Net Sales
//         acc.pretax += pretax;
//         acc.tax += tax;
//         acc.taxfree += taxfree;
//         acc.discount += discount;
//       }
//       if (status === "V") {
//         acc.voidAmount += total;
//         acc.voidCount += 1;
//       }
//       return acc;
//     },
//     {
//       gross: 0,
//       net: 0,
//       pretax: 0,
//       tax: 0,
//       taxfree: 0,
//       discount: 0,
//       voidAmount: 0,
//       voidCount: 0,
//     }
//   );

//   // --- Report Summary section (placed under Transaction Type Summary) ---
//   sheet.addRow([]);
//   sheet.addRow(["📊 REPORT SUMMARY"]);
//   const reportHeader = sheet.addRow(["Metric", "Value"]);
//   reportHeader.eachCell((cell) => Object.assign(cell, headerStyle));

//   const rows = [
//     ["Total Gross Sales", totals.gross],
//     ["Total Net Sales (Total - Discount)", totals.net],
//     ["Total Pretax", totals.pretax],
//     ["Total Tax", totals.tax],
//     ["Total Tax Free", totals.taxfree],
//     ["Total Discount", totals.discount],
//     ["Total Void Amount", totals.voidAmount],
//     ["Total Void Count", totals.voidCount],
//   ];

//   rows.forEach(([label, val], idx) => {
//     const r = sheet.addRow([label, val]);
//     // Format currency for money rows, leave void count as integer
//     if (label !== "Total Void Count") {
//       r.getCell(2).numFmt = '"₱"#,##0.00';
//     }
//   });

//   const buf = await workbook.xlsx.writeBuffer();
//   const blob = new Blob([buf], {
//     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//   });
//   const url = URL.createObjectURL(blob);
//   const link = document.createElement("a");
//   link.href = url;
//   link.download = "sales-report.xlsx";
//   link.click();
//   URL.revokeObjectURL(url);
// }

export async function exportToExcel(filteredData, storess) {
  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Figaro BI Analytics";
  workbook.created = new Date();

  const sheet = workbook.addWorksheet("Sales Report", {
    views: [{ state: "frozen", xSplit: 0, ySplit: 1 }],
  });

  // ========== STYLES ==========
  const darkGreenHeader = {
    font: { bold: true, color: { argb: "FFFFFFFF" }, size: 11, name: "Inter" },
    fill: {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF1F4D2C" },
    },
    alignment: { vertical: "middle", horizontal: "center", wrapText: true },
    border: {
      top: { style: "thin", color: { argb: "FF000000" } },
      left: { style: "thin", color: { argb: "FF000000" } },
      bottom: { style: "thin", color: { argb: "FF000000" } },
      right: { style: "thin", color: { argb: "FF000000" } },
    },
  };

  const greenAccent = {
    font: { bold: true, color: { argb: "FFFFFFFF" }, size: 11, name: "Inter" },
    fill: {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF83C14A" },
    },
    alignment: { vertical: "middle", horizontal: "center" },
  };

  const sectionTitle = {
    font: { bold: true, size: 14, color: { argb: "FF1F4D2C" }, name: "Inter" },
    alignment: { vertical: "middle", horizontal: "left" },
  };

  // ========== TITLE SECTION ==========
  sheet.mergeCells("A1:M1");
  const titleCell = sheet.getCell("A1");
  titleCell.value = "📊 Sales Report - Angels Pizza";
  titleCell.font = {
    bold: true,
    size: 18,
    color: { argb: "FF1F4D2C" },
    name: "Inter",
  };
  titleCell.alignment = { vertical: "middle", horizontal: "center" };
  sheet.getRow(1).height = 35;

  sheet.mergeCells("A2:M2");
  const subtitleCell = sheet.getCell("A2");
  subtitleCell.value = `Store: ${storess} | Generated: ${new Date().toLocaleString()}`;
  subtitleCell.font = {
    italic: true,
    size: 11,
    color: { argb: "FF666666" },
    name: "Inter",
  };
  subtitleCell.alignment = { vertical: "middle", horizontal: "center" };
  sheet.getRow(2).height = 25;

  // Empty row
  sheet.getRow(3).height = 10;

  // ========== DATA TABLE HEADER ==========
  const headerRow = sheet.addRow([
    "Brand",
    "Store",
    "Date",
    "Tran ID",
    "Tran Type",
    "Sales",
    "Payment Type 1",
    "Amount 1",
    "Payment Type 2",
    "Amount 2",
    "Payment Type 3",
    "Amount 3",
    "Status",
    "Items (Code - Description - Amount)",
  ]);

  headerRow.height = 30;
  headerRow.eachCell((cell) => {
    Object.assign(cell, darkGreenHeader);
  });

  // ========== DATA ROWS ==========
  filteredData.forEach((data, idx) => {
    // Extract items
    let itemsText = "";
    if (Array.isArray(data.items)) {
      itemsText = data.items
        .map((item) => {
          const code = item.code || "";
          const desc = item.description || "";
          const amountProp = item.customProperties?.find(
            (p) => p.codeName === "AMOUNT",
          );
          const amount = amountProp?.value || "0.00";
          return `${code} - ${desc} - ₱${amount}`;
        })
        .join("\n");
    }

    const row = sheet.addRow([
      "Angels Pizza",
      storess,
      data.tran_date,
      data.tran_id,
      data.tran_type,
      data.total,
      data.paymenttype,
      data.paymenttypetotal,
      data.paymenttype2,
      data.paymenttype2total,
      data.paymenttype3,
      data.paymenttype3total,
      data.status,
      itemsText,
    ]);

    row.height = 22;

    // Alternating row colors
    const bgColor = idx % 2 === 0 ? "FFF9FAFB" : "FFFFFFFF";
    row.eachCell((cell, colNum) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: bgColor },
      };
      cell.alignment = {
        vertical: "middle",
        horizontal: "left",
        wrapText: true,
      };
      cell.font = { size: 10, name: "Inter" };
      cell.border = {
        top: { style: "thin", color: { argb: "FFE5E7EB" } },
        left: { style: "thin", color: { argb: "FFE5E7EB" } },
        bottom: { style: "thin", color: { argb: "FFE5E7EB" } },
        right: { style: "thin", color: { argb: "FFE5E7EB" } },
      };

      // Right align numbers
      if ([5, 7, 9, 11].includes(colNum)) {
        cell.alignment = { vertical: "middle", horizontal: "right" };
        cell.numFmt = "₱#,##0.00";
      }

      // Center align status
      if (colNum === 12) {
        cell.alignment = { vertical: "middle", horizontal: "center" };
        cell.font = { bold: true, size: 10, name: "Inter" };

        // Color code status
        if (data.status === "C") {
          cell.font.color = { argb: "FF16A34A" }; // Green
        } else if (data.status === "V") {
          cell.font.color = { argb: "FFDC2626" }; // Red
        }
      }
    });
  });

  // Set column widths
  sheet.getColumn(1).width = 15; // Brand
  sheet.getColumn(2).width = 20; // Store
  sheet.getColumn(3).width = 12; // Date
  sheet.getColumn(4).width = 15; // Tran ID
  sheet.getColumn(5).width = 12; // Sales
  sheet.getColumn(6).width = 18; // Payment Type 1
  sheet.getColumn(7).width = 12; // Amount 1
  sheet.getColumn(8).width = 18; // Payment Type 2
  sheet.getColumn(9).width = 12; // Amount 2
  sheet.getColumn(10).width = 18; // Payment Type 3
  sheet.getColumn(11).width = 12; // Amount 3
  sheet.getColumn(12).width = 10; // Status
  sheet.getColumn(13).width = 50; // Items

  // ========== PAYMENT TYPE SUMMARY ==========
  const summaryStartRow = sheet.lastRow.number + 3;
  sheet.addRow([]);
  sheet.addRow([]);

  sheet.mergeCells(`A${summaryStartRow}:C${summaryStartRow}`);
  const paymentTitleCell = sheet.getCell(`A${summaryStartRow}`);
  paymentTitleCell.value = "💳 PAYMENT TYPE SUMMARY";
  Object.assign(paymentTitleCell, sectionTitle);
  sheet.getRow(summaryStartRow).height = 30;

  const paymentHeaderRow = sheet.addRow([
    "Payment Type",
    "Count",
    "Total Sales",
  ]);
  paymentHeaderRow.height = 25;
  paymentHeaderRow.eachCell((cell) => {
    Object.assign(cell, darkGreenHeader);
  });

  const paymentSummary = {};
  filteredData
    .filter((data) => data.status === "C")
    .forEach((data) => {
      ["", "2", "3"].forEach((suf) => {
        const type = data[`paymenttype${suf}`]?.trim();
        const amt = parseFloat(data[`paymenttype${suf}total`]) || 0;
        if (type && type !== "-") {
          if (!paymentSummary[type]) {
            paymentSummary[type] = { count: 0, total: 0 };
          }
          paymentSummary[type].count++;
          paymentSummary[type].total += amt;
        }
      });
    });

  Object.entries(paymentSummary).forEach(([type, { count, total }], idx) => {
    const row = sheet.addRow([type.toUpperCase(), count, total]);
    row.height = 22;

    const bgColor = idx % 2 === 0 ? "FFDBEAFE" : "FFFFFFFF";
    row.eachCell((cell, colNum) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: bgColor },
      };
      cell.font = { size: 10, name: "Inter", bold: colNum === 1 };
      cell.alignment = {
        vertical: "middle",
        horizontal: colNum === 1 ? "left" : "right",
      };
      cell.border = {
        top: { style: "thin", color: { argb: "FFE5E7EB" } },
        left: { style: "thin", color: { argb: "FFE5E7EB" } },
        bottom: { style: "thin", color: { argb: "FFE5E7EB" } },
        right: { style: "thin", color: { argb: "FFE5E7EB" } },
      };

      if (colNum === 3) {
        cell.numFmt = "₱#,##0.00";
      }
    });
  });

  // Payment Total Row
  const paymentTotal = Object.values(paymentSummary).reduce(
    (acc, { count, total }) => {
      acc.count += count;
      acc.total += total;
      return acc;
    },
    { count: 0, total: 0 },
  );

  const paymentTotalRow = sheet.addRow([
    "TOTAL",
    paymentTotal.count,
    paymentTotal.total,
  ]);
  paymentTotalRow.height = 25;
  paymentTotalRow.eachCell((cell) => {
    Object.assign(cell, greenAccent);
    if (cell.col === 3) {
      cell.numFmt = "₱#,##0.00";
    }
  });

  // ========== TRANSACTION TYPE SUMMARY ==========
  const txnStartRow = sheet.lastRow.number + 3;
  sheet.addRow([]);
  sheet.addRow([]);

  sheet.mergeCells(`A${txnStartRow}:C${txnStartRow}`);
  const txnTitleCell = sheet.getCell(`A${txnStartRow}`);
  txnTitleCell.value = "🛒 TRANSACTION TYPE SUMMARY";
  Object.assign(txnTitleCell, sectionTitle);
  sheet.getRow(txnStartRow).height = 30;

  const txnHeader = sheet.addRow(["Transaction Type", "Count", "Total Sales"]);
  txnHeader.height = 25;
  txnHeader.eachCell((cell) => {
    Object.assign(cell, darkGreenHeader);
  });

  const transactionTypes = {
    D: "Dine-in",
    K: "Drive-Thru",
    T: "Take-out",
    G: "GrabFood",
    P: "Pickup",
    U: "Delivery",
    B: "Deltime",
    F: "FoodPanda",
    H: "Tablevibe",
  };

  const tranSummary = {};
  filteredData
    .filter((data) => data.status === "C")
    .forEach(({ tran_type, total }) => {
      const code = tran_type?.trim();
      if (code && transactionTypes[code]) {
        if (!tranSummary[code]) {
          tranSummary[code] = { count: 0, total: 0 };
        }
        tranSummary[code].count++;
        tranSummary[code].total += parseFloat(total || 0);
      }
    });

  Object.entries(tranSummary).forEach(([code, { count, total }], idx) => {
    const row = sheet.addRow([transactionTypes[code], count, total]);
    row.height = 22;

    const bgColor = idx % 2 === 0 ? "FFFEF3C7" : "FFFFFFFF";
    row.eachCell((cell, colNum) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: bgColor },
      };
      cell.font = { size: 10, name: "Inter", bold: colNum === 1 };
      cell.alignment = {
        vertical: "middle",
        horizontal: colNum === 1 ? "left" : "right",
      };
      cell.border = {
        top: { style: "thin", color: { argb: "FFE5E7EB" } },
        left: { style: "thin", color: { argb: "FFE5E7EB" } },
        bottom: { style: "thin", color: { argb: "FFE5E7EB" } },
        right: { style: "thin", color: { argb: "FFE5E7EB" } },
      };

      if (colNum === 3) {
        cell.numFmt = "₱#,##0.00";
      }
    });
  });

  // Transaction Total Row
  const txnTotal = Object.values(tranSummary).reduce(
    (acc, { count, total }) => {
      acc.count += count;
      acc.total += total;
      return acc;
    },
    { count: 0, total: 0 },
  );

  const txnTotalRow = sheet.addRow(["TOTAL", txnTotal.count, txnTotal.total]);
  txnTotalRow.height = 25;
  txnTotalRow.eachCell((cell) => {
    Object.assign(cell, greenAccent);
    if (cell.col === 3) {
      cell.numFmt = "₱#,##0.00";
    }
  });

  // ========== REPORT SUMMARY ==========
  const reportStartRow = sheet.lastRow.number + 3;
  sheet.addRow([]);
  sheet.addRow([]);

  sheet.mergeCells(`A${reportStartRow}:B${reportStartRow}`);
  const reportTitleCell = sheet.getCell(`A${reportStartRow}`);
  reportTitleCell.value = "📊 FINANCIAL SUMMARY";
  Object.assign(reportTitleCell, sectionTitle);
  sheet.getRow(reportStartRow).height = 30;

  const reportHeader = sheet.addRow(["Metric", "Value"]);
  reportHeader.height = 25;
  reportHeader.eachCell((cell) => {
    Object.assign(cell, darkGreenHeader);
  });

  const totals = filteredData.reduce(
    (acc, d) => {
      const total = parseFloat(d.total) || 0;
      const discount = parseFloat(d.discount_amount) || 0;
      const pretax = parseFloat(d.total_pretax) || 0;
      const tax = parseFloat(d.total_tax) || 0;
      const taxfree = parseFloat(d.total_taxfree) || 0;
      const status = d.status?.trim();

      if (status === "C") {
        acc.gross += total;
        acc.net += total - tax;
        acc.pretax += pretax;
        acc.tax += tax;
        acc.taxfree += taxfree;
        acc.discount += discount;
      }
      if (status === "V") {
        acc.voidAmount += total;
        acc.voidCount += 1;
      }
      return acc;
    },
    {
      gross: 0,
      net: 0,
      pretax: 0,
      tax: 0,
      taxfree: 0,
      discount: 0,
      voidAmount: 0,
      voidCount: 0,
    },
  );

  const reportRows = [
    { label: "💰 Total Gross Sales", value: totals.gross, color: "FFDBEAFE" },
    {
      label: "💵 Total Net Sales",
      value: totals.net,
      color: "FFD1FAE5",
      bold: true,
    },
    { label: "📊 Total Pretax", value: totals.pretax, color: "FFF3F4F6" },
    { label: "📈 Total Tax", value: totals.tax, color: "FFFEF3C7" },
    { label: "✅ Total Tax Free", value: totals.taxfree, color: "FFF3F4F6" },
    { label: "🏷️ Total Discount", value: totals.discount, color: "FFFEE2E2" },
    {
      label: "❌ Total Void Amount",
      value: totals.voidAmount,
      color: "FFFECACA",
    },
    {
      label: "🔢 Total Void Count",
      value: totals.voidCount,
      color: "FFFECACA",
      isCount: true,
    },
  ];

  reportRows.forEach(({ label, value, color, bold, isCount }, idx) => {
    const row = sheet.addRow([label, value]);
    row.height = 25;

    row.getCell(1).fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: color },
    };
    row.getCell(1).font = {
      size: 11,
      name: "Inter",
      bold: bold || false,
    };
    row.getCell(1).alignment = { vertical: "middle", horizontal: "left" };
    row.getCell(1).border = {
      top: { style: "thin", color: { argb: "FFE5E7EB" } },
      left: { style: "thin", color: { argb: "FFE5E7EB" } },
      bottom: { style: "thin", color: { argb: "FFE5E7EB" } },
      right: { style: "thin", color: { argb: "FFE5E7EB" } },
    };

    row.getCell(2).fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: color },
    };
    row.getCell(2).font = {
      size: 11,
      name: "Inter",
      bold: bold || false,
    };
    row.getCell(2).alignment = { vertical: "middle", horizontal: "right" };
    row.getCell(2).border = {
      top: { style: "thin", color: { argb: "FFE5E7EB" } },
      left: { style: "thin", color: { argb: "FFE5E7EB" } },
      bottom: { style: "thin", color: { argb: "FFE5E7EB" } },
      right: { style: "thin", color: { argb: "FFE5E7EB" } },
    };

    if (!isCount) {
      row.getCell(2).numFmt = "₱#,##0.00";
    }
  });

  // Set column widths for summary sections
  sheet.getColumn(1).width = Math.max(sheet.getColumn(1).width || 0, 35);
  sheet.getColumn(2).width = Math.max(sheet.getColumn(2).width || 0, 20);
  sheet.getColumn(3).width = Math.max(sheet.getColumn(3).width || 0, 20);

  // Generate and download
  const buf = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buf], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  const tranDates = filteredData.map((d) => d.tran_date?.split(" ")[0]).filter(Boolean).sort();
  const dateLabel =
    tranDates.length === 0
      ? new Date().toISOString().split("T")[0]
      : tranDates[0] === tranDates[tranDates.length - 1]
      ? tranDates[0]
      : `${tranDates[0]}_to_${tranDates[tranDates.length - 1]}`;
  link.download = `Sales_Report_${storess}_${dateLabel}.xlsx`;
  link.click();
  URL.revokeObjectURL(url);
}
